export default __webpack_public_path__ + "static/media/9s.479ab448.svg";